import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { L10nTranslationModule } from 'angular-l10n';
import { ImageModule } from '@nano/common/image';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDividerModule } from 'ng-zorro-antd/divider';

import { EmptyInboxModule, MessageThreadListModule } from '@nano/messages';
import { EnvelopeComponent } from './envelope.component';

@NgModule({
  imports: [CommonModule, L10nTranslationModule, ImageModule, NzBadgeModule, NzDropDownModule, NzDividerModule, MessageThreadListModule, EmptyInboxModule],
  declarations: [EnvelopeComponent],
  exports: [EnvelopeComponent]
})
export class EnvelopeModule {}
